webpackJsonp([51230292354760],{

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SEO = __webpack_require__(12);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _reactSvgInline = __webpack_require__(11);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _serviciiCasierieLarge = __webpack_require__(467);
	
	var _serviciiCasierieLarge2 = _interopRequireDefault(_serviciiCasierieLarge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_React$Component) {
	  _inherits(Page, _React$Component);
	
	  function Page() {
	    _classCallCheck(this, Page);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Page.prototype.render = function render() {
	    var pageSEO = {
	      title: "Servicii plata numerar",
	      description: "Va oferim servicii de casierie pentru imobilul dvs din Bucuresti.",
	      path: "/servicii/plata-numerar/"
	    };
	    return _react2.default.createElement(
	      "div",
	      { className: "o-page__content" },
	      _react2.default.createElement(_SEO2.default, { pageSEO: pageSEO }),
	      _react2.default.createElement(
	        "div",
	        { className: "c-section-gradient" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container u-pv-20 u-pv-30@tablet u-text-center@tablet" },
	          _react2.default.createElement(
	            "h1",
	            { className: "c-page__heading" },
	            "Servicii plata numerar"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "o-container u-pv-20 u-pv-30@tablet u-bg-white" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container o-container--text u-ph-0" },
	          _react2.default.createElement("img", { className: "u-mb-20", src: _serviciiCasierieLarge2.default, alt: "servicii plata numerar" }),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Plata numerar se poate efectua in urmatoarele variante:"
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              "depunere de numerar in contul asociatiei la casieria bancii la care este deschis contul asociatiei de proprietari"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "depunere de numerar in contul asociatiei la ATM (pentru banci precum ING BANK)"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "plata prin terminalele de tip PayPoint, Payzone, Selfpay etc."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "u-text-center" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/preturi/", className: "c-button u-mt-30" },
	              "Solicita o oferta personalizata"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Page;
	}(_react2.default.Component);
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/servicii-casierie-large.92aefec1.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-servicii-plata-numerar-js-8af3215a5abcbbd272a0.js